import React from 'react';
import { mxn, precioVisible, textoFundador } from '../utils/planes';

/**
 * Precio de un plan: precio de lista tachado + precio fundador cuando aplica.
 * `compacto` para el modal; el modo normal es el de la tarjeta de Planes.
 */
export default function PrecioPlan({ plan, periodo = 'mensual', compacto = false }) {
  const p = precioVisible(plan, periodo);
  if (!plan || p.lista === 0) return null;
  const listaMes = periodo === 'anual' ? Math.round(p.lista / 12) : p.lista;
  const etiqueta = textoFundador(p, !!plan.es_fundador);

  return (
    <div>
      <div className="flex items-baseline gap-2 flex-wrap">
        {p.esFundador && (
          <span className={`line-through text-gray-400 ${compacto ? 'text-sm' : 'text-lg'}`}>
            {mxn(listaMes)}
          </span>
        )}
        <span className={`font-bold text-gray-900 dark:text-white ${compacto ? 'text-2xl' : 'text-3xl'}`}>
          {mxn(p.mensualEquivalente)}
        </span>
        <span className="text-gray-500 dark:text-gray-400 text-sm">/mes</span>
      </div>
      {periodo === 'anual' && (
        <p className="text-xs text-green-600 dark:text-green-400 mt-1">
          {p.esFundador && <span className="line-through text-gray-400 mr-1">{mxn(p.lista)}</span>}
          {mxn(p.actual)}/año{p.ahorroPct > 0 ? ` · Ahorras ${p.ahorroPct}%` : ''}
        </p>
      )}
      {etiqueta && (
        <p className="inline-block mt-2 text-xs font-semibold text-amber-700 dark:text-amber-300 bg-amber-100 dark:bg-amber-900/30 px-2 py-0.5 rounded">
          {etiqueta}
        </p>
      )}
    </div>
  );
}
